export default "__VITE_ASSET__DGNhGM_Q__"